import { lazy, Suspense } from "react";
import LoadingPage from "../containers/loading";

const MyshipmentPage = lazy(() =>
  import("../containers/myshipments/myshipments")
);

export default function MyShipmentRoute() {
  return (
    <Suspense fallback={<LoadingPage />}>
      <MyshipmentPage />
    </Suspense>
  );
}
